import React from "react";
import { storyblokEditable } from "@storyblok/react";
import RichTextBlock from "@/storyblok/block-library/rich-texts/RichTextBlock";
import { cn } from "@/storyblok/utils/cn";
import Title from "./Title";

export default function TextOnlySectionBlock({ blok }) {
  const {
    title = "",
    titleAs = "h1",
    content = "",
    contentColor = "textPrimary",
    titleColor = "textPrimary",
  } = blok;

  const sectionClasses = cn({
    "flex flex-col px-10 py-28 md:px-28 lg:px-80 items-center": true,
  });

  const contentClasses = cn("lg:max-w-7xl", {
    "text-textPrimary": contentColor === "textPrimary",
    "text-textSecondary": contentColor === "textSecondary",
    "text-textBlack": contentColor === "textBlack",
    "text-textLight": contentColor === "textLight",
    "text-textWhite": contentColor === "textWhite",
    "text-textGrey": contentColor === "textGrey",
    "text-textOrange": contentColor === "textOrange",
  });

  return (
    <section className="bg-white">
      <div {...storyblokEditable(blok)} className={sectionClasses}>
        <Title
          title={title}
          titleColor={titleColor}
          titleAs={titleAs}
          className={"mb-10 text-center"}
        />
        <RichTextBlock content={content} className={contentClasses} />
      </div>
    </section>
  );
}
